import axios from "../../config/axiosConfig";
import {
  SHORT_EXCESS_REGISTER_REPORT_REQUEST,
  SHORT_EXCESS_REGISTER_REPORT_SUCCESS,
  SHORT_EXCESS_REGISTER_REPORT_FAILURE,
  SHORT_EXCESS_REGISTER_FILTER_REPORT_REQUEST,
  SHORT_EXCESS_REGISTER_FILTER_REPORT_SUCCESS,
  SHORT_EXCESS_REGISTER_FILTER_REPORT_FAILURE,
} from "../types/short-excess-register-types";

export const getShortExcessRegisterReport = (params) => {
  return async (dispatch, getState) => {
    try {
      dispatch({ type: SHORT_EXCESS_REGISTER_REPORT_REQUEST });

      const { auth } = getState();
      const defaultParams = {
        // userId: auth.user?.id,
        finyearId: auth.finyear?.id,
        companyId: auth.company?.id,
        customerId: auth.user?.Customer_Id,
      };

      const defaultParams2 = {
        filterType: params?.filterType, 
        selectedItems: params?.selectedItems, 
        selectedParties: params?.selectedParties, 
        fromDate: params?.fromDate, 
        toDate: params?.toDate, 
        ...params
      };
      // Merge default params with provided params
      const requestParams = { ...defaultParams, ...defaultParams2 };

      // Log the request parameters
      // console.log('Request Param Datas >>>>>>>>>>>>>>>>>>>>>>>>', requestParams);

      // Construct the complete URL with query parameters
      const queryString = new URLSearchParams(requestParams).toString();
      const fullUrl = `/short-excess/getReport?${queryString}`;

      // Log the full URL (to debug)
      console.log('Complete API Request URL: ', fullUrl);

      // Make API call
      return axios.get(fullUrl).then((response) => {
        console.log('API Response Data: ', response);
        // Dispatch success action with data
        if (response.data) {
          dispatch({ type: SHORT_EXCESS_REGISTER_REPORT_SUCCESS, payload: response.data });
        }
      }).catch((error) => {
        console.error("Error fetching Short Excess Register Report:", error);
        dispatch({ type: SHORT_EXCESS_REGISTER_REPORT_FAILURE, error: error.message });
      });
    } catch (error) {
      console.error("Error fetching Short Excess Register Report:", error);
      dispatch({ type: SHORT_EXCESS_REGISTER_REPORT_FAILURE, error: error.message });
    }
  };
};

export const getShortExcessFilterDetail = (params) => {
  return async (dispatch, getState) => {
    try {
      dispatch({ type: SHORT_EXCESS_REGISTER_FILTER_REPORT_REQUEST });

      const { auth } = getState();
      const defaultParams = {
        // userId: auth.user?.id,
        finyearId: auth.finyear?.id,
        companyId: auth.company?.id,
        customerId: auth.user?.Customer_Id,
        // commanMaster: auth?.company?.Common_Master,
      };

      // Merge default params with provided params
      const requestParams = { ...defaultParams };

      // Log the request parameters
      // console.log('Request Param Datas >>>>>>>>>>>>>>>>>>>>>>>>', requestParams);

      // Construct the complete URL with query parameters
      const queryString = new URLSearchParams(requestParams).toString();
      const fullUrl = `/short-excess/getShortExcessFilterDetail?${queryString}`;

      // Log the full URL (to debug)
      console.log('Complete API Request URL: ', fullUrl);

      // Make API call
      return axios.get(fullUrl).then((response) => {
        console.log('API Response Data: ', response);
        // Dispatch success action with data
        if (response.data) {
          dispatch({ type: SHORT_EXCESS_REGISTER_FILTER_REPORT_SUCCESS, payload: response.data });
        }
      }).catch((error) => {
        console.error("Error fetching Short Excess Register Report:", error);
        dispatch({ type: SHORT_EXCESS_REGISTER_FILTER_REPORT_FAILURE, error: error.message });
      });
    } catch (error) {
      console.error("Error fetching Short Excess Register Report:", error);
      dispatch({ type: SHORT_EXCESS_REGISTER_FILTER_REPORT_FAILURE, error: error.message });
    }
  };
};

export const clearShortExcessRegisterReport = () => {
  return async (dispatch) => {
    dispatch({ type: SHORT_EXCESS_REGISTER_REPORT_SUCCESS, payload: {} });
  }
}
